import { Emitter } from "@welshman/lib";
import { Connection } from "./Connection.js";
export class Pool extends Emitter {
    data;
    constructor() {
        super();
        this.data = new Map();
    }
    has(url) {
        return this.data.has(url);
    }
    get(url) {
        const oldConnection = this.data.get(url);
        if (oldConnection) {
            return oldConnection;
        }
        const newConnection = new Connection(url);
        this.data.set(url, newConnection);
        this.emit("init", newConnection);
        return newConnection;
    }
    remove(url) {
        const connection = this.data.get(url);
        if (connection) {
            connection.cleanup();
            this.data.delete(url);
        }
    }
    clear() {
        for (const url of this.data.keys()) {
            this.remove(url);
        }
    }
}
//# sourceMappingURL=Pool.js.map